import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

import type { I_PlatformHandlers } from '@/types/Platforms';

export const PlatformContext = createContext<I_PlatformHandlers | null>(null);

export const usePlatformHandlers = (): I_PlatformHandlers => {
  const context = useContext(PlatformContext);
  if (!context) throw new Error('Context not found');
  return context;
};
